/**
 * Token del link privato di anteprima.
 *
 * 24 byte casuali resi in esadecimale: 48 caratteri, 192 bit di entropia.
 * Non è una password e non protegge da chi riceve il link e lo gira ad altri,
 * serve solo a rendere l'URL impossibile da indovinare.
 */

const TOKEN_BYTES = 24;

export const PREVIEW_TOKEN_LENGTH = TOKEN_BYTES * 2;

export const PREVIEW_PATH = '/anteprima';

export const generatePreviewToken = (): string => {
  const bytes = new Uint8Array(TOKEN_BYTES);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
};

export const isValidPreviewToken = (token: unknown): boolean => {
  if (typeof token !== 'string') return false;
  return new RegExp(`^[0-9a-f]{${PREVIEW_TOKEN_LENGTH}}$`).test(token);
};

/**
 * URL completo da girare al cliente. La base arriva da VITE_WEBSITE_URL così
 * il link copiato dall'amministrazione punta sempre al dominio pubblico, anche
 * quando l'admin è aperto su localhost.
 */
export const buildPreviewUrl = (token: string, baseUrl?: string): string => {
  const base = (
    baseUrl ||
    (import.meta.env?.VITE_WEBSITE_URL as string | undefined) ||
    (typeof window !== 'undefined' ? window.location.origin : '')
  ).replace(/\/+$/, '');

  return `${base}${PREVIEW_PATH}/${token}`;
};
